import { render } from "./VehicleCardFreeItemComponent.vue?vue&type=template&id=d74d2eba"
import script from "./VehicleCardFreeItemComponent.vue?vue&type=script&lang=js"
export * from "./VehicleCardFreeItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__